
var old$=$;
var G;
jQuery.noConflict();
(function( $ ) {
	$(document).ready(function() {
		G=new General();

	});
	var transEnd='transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd';



	// GENERAL
		function General() {
			this.startFunctions();
			this.events();
			this.initFn();
		}

		//fn: nome della funzione
		//sel: selettore es: '.classeElemento' oppure '#idElemento' se false non fa il controllo
		//moreCheck: se sono da aggiungere nuovi controlli
		General.prototype.fnCheck = function(fn, sel, moreCheck) {
			var check=typeof moreCheck==="undefined"?true:moreCheck;
			var selector= typeof sel==="undefined"?true:typeof $(sel)[0] !== 'undefined';
			return typeof fn==="undefined" && selector && check;
		};


		General.prototype.startFunctions = function(first_argument) {
			if(this.fnCheck(this.Home,"#home"))
				this.Home=new Home("#home");

			if(this.fnCheck(this.HideHeader,".hide-header"))
				this.HideHeader=new HideHeader(".hide-header",this);


			if(this.fnCheck(this.ModalCarousel,".trig-carousel"))
				this.ModalCarousel=new ModalCarousel(".trig-carousel");

			if(this.fnCheck(this.doppioScroll,".wrapper-scroll" ))
				this.doppioScroll=new doppioScroll(".wrapper-scroll");
			if(this.fnCheck(this.apriMenu,".button-burger" ))
				this.apriMenu=new apriMenu(".button-burger");
			if(this.fnCheck(this.Modali,".modal" ))
				this.Modali=new Modali(".modal");
			//if(this.fnCheck(this.added,".add-to" ))
				//this.added=new added(".add-to");
			if(this.fnCheck(this.zoomIn,".zoom" ))
				this.zoomIn=new zoomIn(".zoom");
			if(this.fnCheck(this.changeInfo,".form-control" ))
				this.changeInfo=new changeInfo(".form-control");
			if(this.fnCheck(this.modificaQty,".qty-modifica" ))
				this.modificaQty=new modificaQty(".qty-modifica");
			if(this.fnCheck(this.accediPrima,".wishlist-trig" ))
				this.accediPrima=new accediPrima(".wishlist-trig");

			if(this.fnCheck(this.SocialPlugins,"#news.modal" ))
				this.SocialPlugins=new SocialPlugins("#news.modal");

			//if(this.fnCheck(this.removeWish,".remove" ))
			//	this.removeWish=new removeWish(".remove");

			if(this.fnCheck(this.Login,"#login-form" ))
				this.Login=new Login("#login-form");

			if(this.fnCheck(this.Login2,"#login-form-2" ))
				this.Login2=new Login("#login-form-2");
			
			if(this.fnCheck(this.register,"#registration-form" ))
				this.register=new Login("#registration-form");

			if(this.fnCheck(this.forgotPwd,"#forgot-form" ))
				this.register=new Login("#forgot-form");


			if(this.fnCheck(this.AjaxLink,".aj-link" ))
				this.AjaxLink=new AjaxLink(".aj-link");

			if(this.fnCheck(this.AjaxInfo,".aj-info" ))
				this.AjaxInfo=new AjaxInfo(".aj-info");			

			if(this.fnCheck(this.SalesDetails,".aj-prices" ))
				this.SalesDetails=new SalesDetails(".aj-prices");			

			if(this.fnCheck(this.vimeoPlayer,".vimeo-video" ))
				this.vimeoPlayer=new vimeoPlayer(".vimeo-video");

			if(this.fnCheck(this.Newsletter,"#newsletter-validate-detail" ))
				this.Newsletter=new Newsletter("#newsletter-validate-detail");
			if(this.fnCheck(this.slimScroll,".cont-riassunto" ))
				this.slimScroll=new slimScroll(".cont-riassunto");
			if(this.fnCheck(this.noClass,".wrapper-account" ))
				this.noClass=new noClass(".wrapper-account");

			if(this.fnCheck(this.mediaSection,".cont-media .iframe-wrapper" ))
				this.mediaSection=new mediaSection(".cont-media .iframe-wrapper");

			


			//if(this.fnCheck(this.menuLimited,".menu-vetrina" ))
			//	this.menuLimited=new menuLimited(".menu-vetrina");

			this.addToCart=new AddToCart();
			this.addToWishlist=new AddToWishlist();

			this.cookie= new Cookie('.wrapper-cookie');
					

		};
		General.prototype.events = function() {
			var _this= this;

			$(window).on('resize', function(){
				if (typeof _this.doppioScroll != 'undefined'){
					_this.doppioScroll.resize();	
				}
				if (typeof _this.hideHeader != 'undefined'){
					_this.HideHeader.check();	
				}
			});
				var lastY=0;
				var dir;
				$(document).on('touchmove touchend',function (e) {
					if (typeof _this.doppioScroll != 'undefined' && _this.isMobile() && typeof $(e.target).parents(_this.doppioScroll.el)[0]!="undefined"){
						e.preventDefault();
						switch(e.type) {
							case 'touchend':
								
								_this.doppioScroll.ScrollDown(dir);
							break;
							case 'touchmove':
							 var currentY = e.originalEvent.touches[0].clientY;
					     if(currentY > lastY){
					         dir=-1;
					     }else if(currentY < lastY){
					         dir=1;
					     }
					     lastY = currentY;
								
							break;
						}
						console.log('scroll trigger',e.target, e);

						return false;
					}
				})

			$(window).on('scroll', function(e){
				if (typeof _this.doppioScroll != 'undefined'){
					_this.doppioScroll.scroll(e);

					//$('h1').text
				}
				if (typeof _this.vimeoPlayer != 'undefined'){
					_this.vimeoPlayer.scroll(e);
				}

				if (typeof _this.HideHeader != 'undefined'){
					_this.HideHeader.toggle();					
				}
			});
			
			$('#btn-lang').on('hide.bs.dropdown	hidden.bs.dropdown', function () {
				$(this).parent().show();
			});

			$('#login').on('show.bs.modal', function (e) {
				if($(window).width()<641){
					$('html').toggleClass('menu-resp');
				}
				$('.page').css('overflow', 'hidden'); 
			});
			$('#login').on('hidden.bs.modal', function (e) {
				 $('.modal-login .prima-accedi').hide(); 
				 $('.page').css('overflow', 'auto');
			});

			$('#carousel-modal').on('show.bs.modal', function () {
				var zoom= new ZoomInEl($(this).find('.zoomIn')[0]);
			});

			$('body').off('slid.bs.carousel','.carousel').on('slid.bs.carousel','.carousel',function () {
				_this.CarouselCheckArrows(this);
				
			})

			$('.media-mask').off('click').on('click',function (e) {
				console.log(e.target);
				var el=$(this).attr('data-el');
				$('#carousel-modal .item').removeClass('active');
				$('#slide-'+el).addClass('active');
				$('#media-modal').modal('show');
				$('#carousel-modal').carousel(el);
				return false;
			})
		};

		General.prototype.CarouselCheckArrows = function (el) {
			$(el).find('.carousel-control').removeClass('disabled');
			var current=$(el).find('.item.active');
			if(current.hasClass('primo')){
				$(el).find('.carousel-control.left').addClass('disabled');
			}

			if(current.hasClass('last')){
				$(el).find('.carousel-control.right').addClass('disabled');
			}
		}

		General.prototype.initFn = function () {


			//hash checking
			if (window.location.hash && window.location.hash.length>1) {
				$(window.location.hash).collapse('show');
			}


		}

		General.prototype.isMobile = function () {
				// device detection
			if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) 
				return  true;
			return false; //initiate as false
		}

	
	//--- GENERAL

	//MENU LIMITED

		/*function menuLimited(){
			if(!$('.menu-vetrina li').hasClass('select')){
				console.log('pippo');
				$('.select').toggleClass('solo-limited');;


			}
		}*/
	//--MENU LIMITED




	//Home
		function Home(){
			console.log('Home');
		}
	//--HOME
	
	//HIDEHEADER
		function HideHeader(el,G){
			this.G=G;
			this.el=el;
			this.$el=$(el);
			this.header=$('header');
			this.check();
		}

		HideHeader.prototype.check = function () {
			if(this.G.isMobile()){
				this.set();
			}
		}

		HideHeader.prototype.set = function () {
			this.headerHeight=this.header.outerHeight();
			this.elHeight=this.$el.outerHeight();
			$('header').hide();
  		this.toggle();
		}

		HideHeader.prototype.toggle = function (arguments) {
			var show=$(window).scrollTop()>this.headerHeight;
			if(show && !$('header').hasClass('show-header')){
				console.log('down');
				$('header').addClass('show-header').stop().slideDown('400');
			}
			else if(!show && $('header').hasClass('show-header')){
				$('header').removeClass('show-header').stop().slideUp(150);	
			}

		}
	//--HIDEHEADER
	
	//MODAL CAROUSEL
		function ModalCarousel(el){
			this.el= el;
			this.$el= $(el);
			this.single= [];
			this.carousel= $('#carousel-modal');
			var _this= this;
			this.$el.each(function(index, el) {
				var single= new ModalCarouselEl(el, _this.carousel);
				_this.single.push(single);
			});
			console.log(this);



		}
		function ModalCarouselEl(el, carousel){
			this.el= el;
			this.$el= $(el);
			this.carousel= carousel;
			this.modalId= this.$el.attr('data-target');
			this.arrayImmagini= JSON.parse(this.$el.attr('data-immagini'));
			this.events();

		}
		ModalCarouselEl.prototype.events = function() {
			console.log(this.carousel);
			var _this= this;
			this.$el.off('click').on('click', function(){
				
				_this.showModal();

				return false;

			});


			$('body').off('click','.zoom-transition').on('click','.zoom-transition',function (e) {
				var lente;
				console.log(e.target);
				$(this).parents('.cont-carol').find('.zoom-transition').toggleClass('out in');
				if($(this).hasClass('in')){
					$(this).parents('.carousel-inner').addClass('noheight');
					$(e.target).one(transEnd,function () {
						var cont=$(this).closest('.item');
						lente=new Magnify(cont);
					});			
				}else if(typeof lente !=="undefined"){
					$(this).parents('.carousel-inner').removeClass('noheight');
					lente.$el.remove();
				}
				else
					$(this).parents('.carousel-inner').removeClass('noheight');
			});





		};
		ModalCarouselEl.prototype.showModal = function() {
			var carouselPieno= this.riempiCarousel();

			var newCarousel= $(this.modalId).find('.modal-body').html(carouselPieno);

			$(this.modalId).modal();
			$(this.modalId).find('.carousel').carousel({
			  interval: false
			  
			});
			G.CarouselCheckArrows($(this.modalId).find('.carousel')[0]);
			
		};
		ModalCarouselEl.prototype.riempiCarousel = function() {
			var carousel = this.carousel.clone();
			var contenutoCar= carousel.find('.cont-carol');
			var carouselInner= carousel.children('.carousel-inner');
			


			for(var i in this.arrayImmagini){
				if(i<this.arrayImmagini.length){
					
					var imgAr= this.arrayImmagini[i];
					var newContenutoCar= contenutoCar.clone();
					

					for (var i2 in imgAr){
						if(i2 < imgAr.length){
							console.log(imgAr);
							var appImg=$('<img id="img-'+imgAr[i2]['id']+'" class="zoom zoom-transition out" src="'+imgAr[i2]['mid']+'">');
							appImg.attr({
								"data-full"	:JSON.stringify(imgAr[i2]['full']),
								"data-id" 	:imgAr[i2]['id']
							});
							appImg.full=imgAr[i2]['full'];
							newContenutoCar.append(appImg);
						}

					}
					
					if(i==0){
						newContenutoCar.addClass('primo');
					}
								

					if(i==this.arrayImmagini.length-1){
						
						newContenutoCar.addClass('last');
					}					

					carouselInner.append(newContenutoCar);
					//var zoom=new zoomIn('.zoompress',imgAr[i2]['full']);

				}
			}
			if(this.arrayImmagini.length==1){
				carousel.find('.carousel-control').hide();
			}
			

			
			contenutoCar.remove();
			carousel.find('.cont-carol:first').addClass('active');

			return carousel;
		};
	//--MODAL CAROUSEL	


	//DOPPIO SCROLL
		function doppioScroll(el){
			this.el=el;
			this.$el= $(el);
			this.wrapperColonne= $(el).find('.wrapper-colonne');
			this.box= $(el).find('.box');	
			this.boxDx= $(el).find('.right');
			this.boxSx=$(el).find('.left');
			this.boxSxChild=this.boxSx[0].childElementCount;
			this.nImg=this.boxDx.children().length;
			this.valore= 0;
			this.indicatori= typeof $('.indicatore')[0]!= 'undefined';

			this.isMobile = false; //initiate as false
				// device detection
			if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) 
				this.isMobile = true;

			//if(this.isMobile){
			//	this.mobileEdit();
			//}
			//else{
			//	this.setHeight();
			//}
				this.setHeight();
				this.events();
		}

		doppioScroll.prototype.mobileEdit = function () {
			console.log(this.$el, this.boxDx);
			this.boxDx.children().each(function(index, el) {
				//$(this).appendTo(this.boxDx);
				
				$(this).parent().prepend(this);
			});
			this.setHeight();
		}

		doppioScroll.prototype.setHeight = function() {

			this.altSchermo= $(window).height();
			this.box.height(this.altSchermo);
			this.altTotale= this.altSchermo * this.nImg;
			this.$el.height(this.altTotale);

			this.scroll();
			
		};
		doppioScroll.prototype.resize = function() {
				this.setHeight();
		};
		doppioScroll.prototype.spostamentoDx = function(posValore) {
			var spostamento = this.altSchermo * (this.nImg - 1)-posValore *2;
			var spostamentoFreccia = this.altSchermo -50 + posValore;
			if( this.altSchermo * (this.nImg - 1)-posValore>0 && posValore>=0){
				//if(!this.isMobile)
					this.boxDx.css('transform','translateY('+( -1*Math.floor(spostamento))+'px)');
				$('.giu').css('position', 'fixed');

				$('.newsletter').addClass('fixed');
				//$('.newsletter').removeClass('bottom');
				
			}
			else if(posValore<0){
				//if(!this.isMobile)
					this.boxDx.css('transform','translateY('+(Math.floor(-1*this.altSchermo * (this.nImg - 1)))+'px)');
			}
			else{
				//if(!this.isMobile)
					this.boxDx.css('transform','translateY('+(Math.floor(this.altSchermo * (this.nImg - 1)))+'px)');
				$('.giu').css('position', 'absolute');
				

			}

			//$('h1.logo').text();
			if(this.altSchermo * (this.nImg - 1)-posValore<0){
				$('.newsletter').removeClass('fixed');
				//$('.newsletter').addClass('bottom');
			}
			


		};
		doppioScroll.prototype.scroll = function(e) {
			
				var pos= $(window).scrollTop();
				var valore= this.$el.offset().top;
				var trigger= pos-valore + this.altSchermo/2;
				this.elementoCorrente=Math.floor(trigger/this.altSchermo);


				this.spostamentoDx(pos-valore);
				
				if(this.indicatori){
					this.setSelezionato(pos-valore);
				}

		};

		doppioScroll.prototype.events = function() {
			var _this= this;
			$('.indicatore').on('click', function(){
				var href= $(this).attr('href');

				_this.goToBlocco(href);
				return false;
			});

			$('.giu').on('click', function(){
				
				_this.ScrollDown(1);
				
				return false;
			});
		};

		doppioScroll.prototype.ScrollDown = function (dir) {
			var posizione;
			var timer= 900;
			if((dir>0 && this.elementoCorrente<this.boxSxChild-1) || (dir<0 && this.elementoCorrente>0)){
				
				posizione= this.boxSx.children().eq(this.elementoCorrente+dir).offset().top;
				timer= 500;

				
				
			}
			else if(typeof this.$el.next()[0]!='undefined' && dir>0){
				
				posizione= this.$el.next().offset().top;			
			}
			else if(typeof this.$el.prev()[0]!='undefined' && dir<0){
				posizione= this.$el.prevAll('div:last').offset().top;
			}
			else{
				if(dir<0){
					posizione=0;
				}
				else{
					posizione=$('footer').offset().top;
				}
			}
			$('html,body').stop().animate({
		        scrollTop: posizione
		    },timer);
		};

		doppioScroll.prototype.goToBlocco = function(href) {
			var bloccoClik= $(href).offset().top;
			$('html,body').stop().animate({
	        scrollTop: bloccoClik
	    	},'slow');
		};
		doppioScroll.prototype.setSelezionato = function(posValore) {
		    
		    var selettoreCorrente= $('.indicatore').eq(this.elementoCorrente);
		    if(! selettoreCorrente.hasClass('select')){
		    	$('.indicatore').removeClass("select");
			    selettoreCorrente.addClass("select");
		    }
		    	
		};
	//--DOPPIO SCROLL

	//MENU RESPONSIVE
		function apriMenu(){
			$('.button-burger').on('click', function(){
				$('html').toggleClass('menu-resp');	
				$('.modal').modal('hide');
				$('#forgot').modal('hide');
			});
		}

	//--MENU RESPONSIVE

	//MODAL
		function Modali(){
				$(document).on('show.bs.modal', '.modal', function (event) {
	            var zIndex = 1040 + (10 * $('.modal:visible').length);
	            $(this).css('z-index', zIndex);
	            setTimeout(function() {
	                $('.modal-backdrop').not('.modal-stack').css('z-index', zIndex - 1).addClass('modal-stack');
	            }, 0);
	            
			});
		}

	//--MODAL

	/*ADD TO WISHLIST
		function added(){
			$('.add-to').on('click',function(){
				$(this).parent().parent().addClass('add-si');
			});
		}
	//--ADD TO WISHLIST*/

	//ZOOM
		function zoomIn(el) {
			this.el=el;
			this.$el=$(el);
			this.arr=[];
			var _this=this;
			this.$el.each(function(index, el) {
				var single=new ZoomInEl(el);
				_this.arr.push(single);
			});
		}	

		function ZoomInEl(el,bigImg) {
			this.el=el;
			this.$el=$(el);
			console.log($('body').find(this.$el));
			this.cont=this.$el.parents('.zoomIn');
			var _this=this;
			this.$el.one('load',function () {
				_this.setUp(bigImg);
			})
		}

		ZoomInEl.prototype.setUp = function (bigImg) {
			this.size=[this.$el.width(),this.$el.height()];
			this.cont.innerWidth(this.size[0]).innerHeight(this.size[1]);
			
			if(typeof bigImg =="undefined"){
				this.imgBig=this.$el.clone();
				this.imgBig.width(this.size[0]*2);
				this.bigSize=[this.imgBig.width(),this.imgBig.height()];

			}
			else{
				this.imgBig= new Image(bigImg[1],bigImg[2]);
				this.imgBig.src=bigImg[0]
				this.bigSize=[bigImg[1],bigImg[2]];
			}

			this.events();
		}

		ZoomInEl.prototype.events = function () {
			var _this=this;
			console.log(this.cont);
			this.cont
				.off('mouseenter touchstart').on('mouseenter touchstart',function () {
					_this.imgBig.hide().prependTo(_this.cont).css('position','relative').stop(true,true).fadeIn(100);
					return false;
				})
				.off('mousemove touchmove').on('mousemove touchmove',function (e) {
					
					var mouseX = e.pageX - $(this).offset().left;
			      var mouseY = e.pageY - $(this).offset().top;
			      var amountMovedX = Math.round(mouseX / _this.size[0] * 100) / 100 * (_this.bigSize[0] - _this.size[0]);
			      var amountMovedY = Math.round(mouseY / _this.size[1] * 100) / 100 * (_this.bigSize[1] - _this.size[1]);
			      _this.imgBig.css({
			        'top': amountMovedY + 'px',
			        'left': -amountMovedX + 'px',
			      });
				})
				.off('mouseleave touchend').on('mouseleave touchend',function () {
					_this.imgBig.stop(true,true).fadeOut(100, function() {
						var __this=this;
						setTimeout(function() {
							_this.imgBig.remove();
						},100)
					});
					return false;
				})

		}
	//--ZOOM

	//CAMBIO INFO SU ACCOUNT
		function changeInfo(){
			$('.form-account .form-control').on('click', function(){
				$('.repeat-password, .btn-save').addClass('visibile');
				return false;
			});
			
		}

	//--CAMBIO INFO SU ACCOUNT

	/*REMOVE WISH
		function removeWish(){
			$('.remove').on('click', function(){
				$(this).parent().parent().hide('slow');
			});
		}
	//--REMOVE WISH*/

	//ACCEDI PRIMA
		function accediPrima(){
			$('.wishlist-trig').on('click', function(){
				$('#login').modal('show');
				$('.modal-login .prima-accedi').show();
				
			});
		}
	//--ACCEDI PRIMA


	//LOGIN
		function Login(el) {
			this.el=el;
			this.$el=$(el);

			this.events();
		}

		Login.prototype.events = function () {
			var _this=this;
			this.$el.on('submit',function () {
				var data=$(this).serialize();
				$(this).addClass('loading');
				_this.ajaxCall(data);
				return false;
			})
		}

		Login.prototype.ajaxCall = function (data) {
			var _this=this;
			var action=this.$el.attr('action');
			var method=this.$el.attr('method');
			this.$el.removeClass('has-error');
			$.ajax({
				url: action,
				type: method,
				
				data: data,
			})
			.done(function(data) {
				var json=JSON.parse(data);
				switch(json.status) {
					case "success":
						console.log(typeof json.notredirect && json.notredirect,typeof json.notredirect , json.notredirect);
						if(typeof json.notredirect && json.notredirect){
							_this.$el.removeClass('loading');
							_this.$el.parents('.modal-body').find('.control').removeClass('hide').children('h5').text(json.message);

						}
						else
						window.location.href=window.location.href;
						break;
					default:
						_this.$el.removeClass('loading');
						_this.showError(json);
						break;
				}
			})
			.fail(function(data) {
				console.log("error",data);
			})
			.always(function(data) {
				
				$(this).removeClass('loading');
			});
		}

		Login.prototype.showError = function (data) {
			console.log(data.message, typeof data.message);
			var msg=data.message;
			if(typeof data.message=="Array"){
				msg='<span class="block">'+msg.join('</span><span class="block">')+'</span>';
			}
			this.$el.find('.unvalid').html(data.message);
			this.$el.addClass('has-error');
		}
	//--LOGIN

	
	//AJAX LINK
		function AjaxLink(el) {
			this.el=el;
			this.$el=$(el);
			this.arr=[];
			var _this=this;
			this.$el.each(function(index, el) {
				var single=new AjaxLinkEl(el);
				_this.arr.push(this.arr);
			});
		}

		function AjaxLinkEl(el) {
			console.log('test');
			this.el=el;
			this.$el=$(el);

			this.events();
		}

		AjaxLinkEl.prototype.events = function () {
			var _this=this;
			this.$el.off('click').on('click',function (e) {
				e.preventDefault();
				var href;
				if(typeof $(this).attr('href')=="udefined"){
					href=$(this).attr('data-href');
				}
				else
					href=$(this).attr('href');
				var aj=new AJAX(href,'GET');
				_this.response(aj);
				return false;
			})
		}

		AjaxLinkEl.prototype.response = function (res) {
			res.response.done(function(data) {
				var successMsg=$(data).find('.success-msg').text();
				console.log(successMsg);
			});

			
		}
	//--AJAX LINK
	
	//AJAX
		function AJAX(href,type,data) {
			var arrData={
					url: href,
					type: typeof type=="undefined"?"GET":type,
				}
				if (typeof data !=="undefined"){
					arrData.data=data;
				}
			this.response=$.ajax(arrData);
			
		}
	//AJAX

	//COOKIE
		function Cookie (cookieCont) {
			this.$cont=$(cookieCont);
			this.Name="cookiePolicy";
			
			//per rimuovere il cookie
			//$.removeCookie(this.Name);

			this.exDays=365;
			var visible=this.check(this.Name);
			
			if(visible){
				this.$cont.show();
				this.trigger();
			}
		}

		Cookie.prototype.check = function(name) {
			
			if(sessionStorage.getItem(name)){
				this.set();
			}

			if(typeof $.cookie(name)=== "undefined" || $.cookie(name)!== 'true'){
				return true;
			}
			else{
				sessionStorage.setItem(name,true);
				return false;
			}
		};

		Cookie.prototype.set = function() {
			var _this=this;
			sessionStorage.setItem(this.Name,true);
			$.cookie(this.Name, true, { expires: this.exDays });
		};

		Cookie.prototype.trigger = function() {
			var _this=this;
			this.$cont.find('.btn-ok').on('click',function () {
				_this.set();
				_this.$cont.stop().slideUp(300);
				return false;
			});
		};
	//--COOKIE
	
	//ADDTOCART
		function AddToCart() {
			this.miniCart={
				cont:$('.wrapper-contatore'),
				num:parseInt($('.wrapper-contatore > .contatore > .numero')),
				submenu:$('.wrapper-contatore > .sottomenu')
			};

			this.events();
		}

		AddToCart.prototype.events = function () {
			var _this=this;
			$('#product_addtocart_form').on('submit',function(e) {
				e.preventDefault();
				_this.submitEl=this;
				var url=$(this).attr('action');
				var method=$(this).attr('method');
				var dati=$(this).serialize();
				dati += '&isAjax=1'; 
				$(this).addClass('loading');
				
				var aj=new AJAX(url, method,dati);
				_this.send(aj);

				return false;
			})
		}

		AddToCart.prototype.send = function (aj) {
			var _this=this;
			console.log(aj);
			$('.aggiunto').stop().slideUp('100');
			aj.response.done(function (data) {
				data=JSON.parse(data);
				console.log(data);
					if(data.status=="SUCCESS"){
						$('.aggiunto').stop().slideDown('800');
						$('.scheda .wrapper-button').hide();

						//$('.wrapper-contatore .numero').text(parseInt($('.wrapper-contatore').text())++);
						_this.updateContatore(data);
						//var data=$('.aggiunto').

					}else{
						//console.log(data);
						//alert('todo -->', data);
						$('.esaurito').stop().slideDown('800');
						$('.scheda .wrapper-button').hide();

					}
				}).always(function (argument) {
					console.log('in aleway');
					$(_this.submitEl).removeClass('loading');
				})
		}

		AddToCart.prototype.increment = function (el) {
			var nContatore = parseInt(el.text());
			var addContatore = nContatore +1;
			el.text(addContatore);
		}
		AddToCart.prototype.updateContatore = function(data) {
			var prod=data.prod;
			var id=$('#el-'+prod.id);
			this.increment($('.wrapper-contatore .contatore .numero'));
			$(this.submitEl).removeClass('loading');
			if (id.length >0){
				this.increment(id.find('.numeroqty'));
				$('.cont-cart .cont-total .total').text(data.subtotal);
			}else{
				if($('.cont-cart .cont-capo').length>3){
					$('.cont-cart .cont-capo:last()').remove();
				}


					$('p.empty').hide();
					var newitem= $('.cont-cart .cont-capo.no-show').clone();
					console.log('come sta contcapo?', newitem.length, newitem);
					newitem.attr('id','el-'+prod.id);

					var prezzo=prod.price;					
					

					newitem.find('.name').text(prod.name);
					newitem.find('.li-colore .color').text($('.colore input:checked').attr('data-name'));
					newitem.find('.li-taglia .taglia').text($('.wrapper-taglie input:checked').attr('data-name'));
					newitem.find('.quantita .numeroqty').text(prod.qty);
					newitem.find('.li-prezzo .prezzo').text(prezzo);
					newitem.find('.capo img').attr('src', $('.aggiunto img').attr('src'));

					if($('.cont-cart .cont-capo').length<2){
						$('.cont-total.no-show, .cont-checkout.no-show').removeClass('no-show');						
					}
					$('.cont-total .total').text(data.subtotal);
					console.log($('.cont-cart .cont-capo.no-show')[0]);

					$('.cont-cart .cont-capo.no-show').after(newitem);
					newitem.removeClass('no-show');
					console.log(newitem);


				
				



					
			}
			console.log(prod);
		};
	//--ADDTOCART

	//ADD TO WISHLIST

		function AddToWishlist() {
			$('.msg-conferma').hide();
			$('.add-wishlist').on('click', function(){
				
				setTimeout(function(){
					$('.msg-conferma').stop().slideDown('600');
					$('.add-wishlist').hide();
				}, 600);
				
				
			});
			
			
		}


		
	//--ADD TO WISHLIST

	//Modifica Qty
		function modificaQty(el){
			this.el= el;
			this.$el= $(el);
			this.arr= [];
			var _this= this;
			this.$el.each(function(index, el) {
				var single = new modificaQtyEl(el);
				_this.arr.push(single);
			});


		}
		modificaQty.prototype.aggiornaTot = function() {
			var totale= 0;
			
			for(var i=0; i<this.arr.length; i++){
				if(i != 'each'){
					var el= this.arr[i];
					totale += el.moltiplicazione();
				}
			}
			var totTxt=totale.toString();
			var split=totTxt.split('.');
			var totDef= split[0]+","+ (typeof split[1] =="undefined"?"00":toString(split[1]) + "00").substring(0,2) + ' €';
			$('.total span.price').text(totDef);
		};
		function modificaQtyEl(el){
			this.el= el;
			this.$el= $(el);
			this.btn= this.$el.children('.btn-modifica');
			this.input= this.$el.children('.input-qty');
			this.span=this.$el.children('.span-qty');
			this.prezzo= this.$el.parents('.blocco-carrello').find('span.price').text();
			console.log(this.prezzo);
			this.prezzo= parseInt(this.prezzo.substring(0,this.prezzo.length-2).replace(',','.'));
			this.qty= parseInt(this.input.val());
			this.events();
		}
		modificaQtyEl.prototype.events = function() {
			var _this=this;
			this.btn.on('click', function(){
				var add=$(this).hasClass('btn-piu')?1:-1; 
				_this.salva(_this.addQty(add));
				return false;
			});
		};
		modificaQtyEl.prototype.addQty = function(add) {
			var valore= parseInt(this.input.val());
			var valoreNew= valore + add;
			if(valoreNew<1){
				valoreNew= valore;
			}
			
			this.qty=valoreNew;
			return valoreNew;
		};
		modificaQtyEl.prototype.stampa = function(valoreNew) {
			this.input.val(valoreNew);
			this.span.text(valoreNew);
		};
		modificaQtyEl.prototype.salva = function(valore) {
			var _this=this;
			this.stampa(valore);
			G.modificaQty.aggiornaTot();
			this.$el.parents('form').addClass('loading').submit();
			//var form = this.$el.parents('form');
			//var aj= new AJAX(form.attr('action'), form.attr('method'),form.serialize());
			//var cont=this.$el.parents('.prodotto-cart');
			//cont.addClass('loading');
			//aj.response.done(function(data) {
			//	//console.log('RESULT', data);
			//}).always(function () {
			//cont.removeClass('loading');
			//})

		};
		modificaQtyEl.prototype.moltiplicazione = function() {

			return this.prezzo * this.qty;
		};
	//Modifica Qty
	
	//SOCIAL PLUGINS
		function SocialPlugins(el) {
			this.el=el;
			this.$el=$(el);
			this.setFB();
			this.setIS();
			this.events();


		}

		SocialPlugins.prototype.setFB = function () {
			var _this=this;
			$.ajaxSetup({ cache: true });
		  $.getScript('//connect.facebook.net/en_US/sdk.js', function(){
		    _this.FB=FB
		    _this.FB.init({
		      appId: '132700123902598',
		      version: 'v2.8' // or v2.1, v2.2, v2.3, ...
		    }); 
	    });    
		}

		SocialPlugins.prototype.setIS = function () {
			var _this=this;
			$.getScript('//platform.instagram.com/en_US/embeds.js',function() {
				_this.IS=instgrm;
			});
		}

		SocialPlugins.prototype.events = function () {
			var _this=this;
			this.galleryCont=_this.$el.find('#carousel-modal-news').clone();
			this.$el.on('show.bs.modal',function (e) {
				var relTarget=e.relatedTarget;
				var $reltar=$(relTarget);
				var social=$reltar.attr('data-news-type');
				var newsId=$reltar.attr('data-news-id');
				var newsUrl=$reltar.attr('data-news-url');

				_this.$el.find('.modal-body').empty();
				switch(social) {
					case 'fb':
						_this.appendFB(newsUrl);
						break;
					case 'is':
						_this.appendIS($reltar.attr('data-html'));
						break;
					case 'gal':
						_this.appendGal($reltar.attr('data-gallery'));
					break;
				}
			});
		}

		SocialPlugins.prototype.appendFB = function (url) {
			var W=Math.floor((this.$el.width()*(33/100))-20);
			this.$el.find('.modal-body').append('<div class="fb-post" data-href="'+url+'" data-width="'+W+'px" data-show-text="true"></div>')
			this.FB.XFBML.parse();
		}

		SocialPlugins.prototype.appendIS = function (html) {
			this.$el.find('.modal-body').append(html);
			this.IS.Embeds.process();
		}

		SocialPlugins.prototype.appendGal = function (arrData) {
			arrData=$.parseJSON(arrData);
			var carousel=this.galleryCont.clone();
			carousel.find('.item').remove();
			var inner=carousel.find('.carousel-inner');
			var l=arrData.length;
			for(var i=0; i<l; i++){
				var el=arrData[i];
				var div=document.createElement('div');
				$(div).attr({
					id:'imgid-'+el.id,
					class: 'item cont-carol'+(i==0?' active':'')
				})
				.append('<img src="'+el.url+'" />');
				if(el.txt!==null && typeof el.txt!== 'undefined' && el.txt.length>0){
					$(div).append('<div class="desc">'+el.txt+'</div>');
				}
				inner.append(div);
			}

			this.$el.find('.modal-body').append(carousel);
			carousel.carousel();

		}
	//-- SOCIAL PLUGINS
	
	//MAGNIFY
		function Magnify(el) {
			this.radius=200/2;
			this.el=el;
			this.$el=$(el);
			this.setup();
			
		}

		Magnify.prototype.events = function () {
			var _this=this;
			
			//this.$el
			//.on('mouseenter',function (e) {
			//	console.log('enter',e);
			//	_this.moveImage(e.clientX-offs.left,e.clientY-offs.top);
			//	_this.lente.offset({top:e.pageY-_this.radius,left:e.pageX-_this.radius}).show();
			//	_this.lente.removeClass('size-0');
			//})
			//.on('mouseleave',function (e) {
				//console.log('remove',e);
				setTimeout(function () {
					_this.lente.hide();
				},500)
				
				//_this.hide();
			//})

			$('body')
			.off('mousemove').on('mousemove',function (e) {
				//console.log(e.target,e);
				//console.log(e.offsetX, e.clientX,e.pageX,e.screenX);
				//console.log(e.offsetY, e.clientY,e.pageY,e.screenY);
				var offs=_this.$el.offset();
				_this.moveImage(e.pageX-offs.left,e.pageY-offs.top);
				_this.lente.offset({top:e.pageY-_this.radius,left:e.pageX-_this.radius});

				if(_this.insquare(e.pageX,e.pageY)){
					_this.showLente();
				}
				else{
					_this.hideLente();
				}

			})
			.one('click',function () {
				_this.remove();	
			});
		}

		Magnify.prototype.insquare = function (w, h) {
			return h>=this.imgSquare[0] && h<=this.imgSquare[2] && w>=this.imgSquare[3] && w<=this.imgSquare[1]; 
		}

		Magnify.prototype.hideLente = function () {
			if(this.visible){
				this.lente.stop(true,true).fadeOut('200',function () {
					this.visible=false;
				});
			}
			else
				this.lente.hide()
		}

		Magnify.prototype.showLente = function () {
			if(this.visible){
				this.lente.show();
			}
			else{
				this.lente.stop(true,true).fadeIn('200',function () {
					this.visible=true;
				});
			}
		}

		Magnify.prototype.remove = function () {
			this.$el.off('mousemove moseenter mouseleave');
			$('body').off('mousemove moseenter mouseleave');
			this.hideLente();
			this.lente.remove();
			delete this;
		}

		Magnify.prototype.moveImage = function (x,y) {
			var xP=-1*(x/this.imgSize[0])*this.fullImg[1]+this.radius;
			var yP=-1*(y/this.imgSize[1])*this.fullImg[2]+this.radius;
			//console.log(y, yP)
			this.imgLente.css('transform','translate('+xP+'px,'+yP+'px)');
		}

		Magnify.prototype.setup = function () {
			var _this=this;
			this.imgSize=[this.$el.width(),this.$el.height()];
			var offs=this.$el.offset();
			this.imgSquare=[
				offs.top,
				offs.left+this.imgSize[0],
				offs.top+this.imgSize[1],
				offs.left
			];
			if(this.$el.find('img').length>1){
				
				this.fullImg=[[],0,0];
				this.$el.find('img').each(function(index, el) {
					var arr=JSON.parse($(this).attr('data-full'));
					_this.fullImg[0].push(arr[0]);
					var nW=Math.min(1340,arr[1]);
					arr[2]=arr[2]/arr[1]*nW;
					arr[1]=nW;
					if(_this.fullImg[1]>0){
						_this.fullImg[1]=Math.min(_this.fullImg[1],arr[1]);
						_this.fullImg[2]+=(arr[2]/arr[1])*_this.fullImg[1];
					}
					else{
						_this.fullImg[1]=arr[1];
						_this.fullImg[2]+=(arr[2]/arr[1])*arr[1];
					}
				});
			}
			else{
				if (!this.$el.is('img')) {
					this.$el=this.$el.find('img');
				}
				this.fullImg=JSON.parse(this.$el.attr('data-full'));
				this.fullImg[0]=[this.fullImg[0]];
			}

			//continuare da qui

			if(this.imgSize[0]*1.5<this.fullImg[1] && (this.$el.hasClass('in') || this.$el.find('img').hasClass('in'))){
				//if(this.fullImg[1]>1340){
				//	var h=this.fullImg[2]/this.fullImg[1];
				//	this.fullImg[1]=1340;
				//	this.fullImg[2]=1340*h;
				//		
				//}
				//this.fullImg[1]=this.fullImg[1]>this.imgSize[0]*2?this.imgSize[0]*2:this.fullImg[1];
				//this.fullImg[2]=this.fullImg[2]>this.imgSize[1]*2?this.imgSize[1]*2:this.fullImg[2];
				var div=document.createElement('div');
				$(div).attr({
					id:"lente-ingrandimento",
					class:"size size-0"
				});
				
				var inDiv=document.createElement('div');
				$(inDiv).addClass('lens-cont');
				var c=this.fullImg[0].length;
				var loaded=0;

				for (var i=0; i<c; i++) {
					var img='<img src="'+this.fullImg[0][i]+'" width="'+this.fullImg[1]+'" />';
					$(inDiv).append(img);
					$(div).append(inDiv);
					this.lente=$(div);
					this.imgLente=$(inDiv);
					$('body').append(this.lente);
					this.events();
					
					//img.on('load', function(event) {
					//	$(inDiv).append(img);
					//	loaded++;
					//		if(loaded==c){
					//		}
					//});
				}				
				//img.on('load',function (e) {
				//})
			}
		}
	//--MAGNIFY
	
	//VIMEOPLAYER
		function vimeoPlayer(el) {
			this.el=el;
			this.$el=$(el);
			this.cont=[];
			var _this=this;
			this.$el.each(function(index, el) {
				if(typeof $(this).attr('id')=='undefined'){
					$(this).attr('id','vimeovid-'+index);
				}
				var sel=new vimeoPlayerEl(this);
				_this.cont.push(sel);
			});
		}

		vimeoPlayer.prototype.scroll = function (e) {
			var l=this.cont.length;
			for(var i=0; i<l; i++){
				this.cont[i].scrolla(e);
			}
		}

		function vimeoPlayerEl(el) {
			this.el=el;
			this.$el=$(el);
			this.id=this.$el.attr('id');

			this.newVideo();
		}

		vimeoPlayerEl.prototype.newVideo = function () {
			var id=this.$el.attr('data-id');
			var player=new Vimeo.Player(this.$el,{
				id:id,
				color: 'ffffff',
				byline:false,
				portrait:false,
				title: false
			});
			this.video=player;

			this.events(player);
		}

		vimeoPlayerEl.prototype.events = function (player) {
			var _this=this;
			
			player.on('ended',function (e) {
				$('body').removeClass('video-playing');
				_this.scrollAway();
				_this.resume();
			});
			player.on('pause',function (e) {
				$('body').removeClass('video-playing');
			});
			player.on('play',function () {
				$('body').addClass('video-playing');
			})
		}

		vimeoPlayerEl.prototype.scrolla = function (e) {
			var videoZone=[
				this.$el.offset().top,
				this.$el.offset().top+this.$el.outerHeight()
			]
			var pos= $(window).scrollTop();
			var altWin=$(window).height();
			winTop=pos;
			winBot=pos+altWin;

			var discriminante=videoZone[0]+this.$el.outerHeight()/2;

			if(winTop>discriminante || winBot<discriminante ){
				this.video.pause();
			}		
		}

		vimeoPlayerEl.prototype.resume = function () {
			this.video.setCurrentTime(0);
			
			this.video.element.src=this.video.element.src;

		}

		vimeoPlayerEl.prototype.scrollAway = function () {
			var _this=this;
			var parent=this.$el.closest('.home-part');
			console.log(parent, parent.siblings('.home-part').length);
			if(parent.siblings('.home-part').length>0 ){
				var pos=parent.siblings('.home-part').offset().top;
				console.log('scrolla to pos',pos);
				$('html,body').stop().animate({
				        scrollTop: pos
				    },1000);
			}
		}
	//--VIMEOPLAYER 
	
	//AJAXINFO
		function AjaxInfo(el) {
			this.el=el;
			this.$el=$(el);
			this.cont=[];
			var _this=this;
			this.$el.each(function(index, el) {
				var sel=new AjaxInfoEl(this);
				_this.cont.push(sel);
			});
		}

		AjaxInfo.prototype.update = function () {
			this.cont=[];
			this.$el=$(this.el);
			var _this=this;
			this.$el.each(function(index, el) {
				var sel=new AjaxInfoEl(this);
				_this.cont.push(sel);
			});

		}

		function AjaxInfoEl(el) {
			this.el=el;
			this.$el=$(el);
			this.notCalling=true;
			this.events();
		}

		AjaxInfoEl.prototype.events = function () {
			var _this=this;
			this.$el.off('click').on('click',function () {
				var href=typeof $(this).attr('href')=='undefined'?(typeof $(this).attr('data-href')=='undefined'?false:$(this).attr('data-href')):$(this).attr('href');
				var moreAction=false;
				switch($(this).attr('data-toggle')) {
					case 'modal':
						_this.$modal=$($(this).attr('data-target'));
						moreAction={
							loading:$($(this).attr('data-target')).find('.modal-content'), 
							target: $(this).attr('data-target'),
							form:$(this).attr('data-form'),
							id:$(this).attr('data-addressid'),
							action:$(this).attr('data-action'),
						};
						if(typeof $(this).attr('data-title')!=='undefined'){
							_this.$modal.find('h5').text($(this).attr('data-title'));
						}
						_this.$modal.modal();	
						_this.editId=moreAction.id;
					break;
				}
				_this.call(href,moreAction);
				return false;
			})
		}

		AjaxInfoEl.prototype.call = function (href,moreAction) {
			if(href){
				var _this=this,
						loading=true;
				if(moreAction){
					if(typeof moreAction == 'object'){
						
						for (var i in moreAction) {
							switch(i){
								case 'loading':
									$(moreAction[i]).addClass('loading');
									loading=true;
								break;
								case 'target': 
								var target=$(moreAction[i]);
								break;
							}
						}
					}
				}
				if(this.notCalling){
					this.notCalling=false;
					if($(moreAction.target).find('form').length>0)
						$(moreAction.target).find('form')[0].reset();
					this.aj=new AJAX(href,'GET',{ajax:true});
					this.aj.response.done(function (data) {
						if(loading){
							$(moreAction.loading).removeClass('loading');
						}
						_this.notCalling=true;
						var form=$(data).find(moreAction.form);
						$(moreAction.target).find('form').attr('action', typeof moreAction.action =="undefined"?form.attr('action'):moreAction.action);
						form.find('input, textarea, select').each(function(index, el) {
							var idel='#'+$(this).attr('id');
							$(moreAction.target).find(idel).val($(this).val());
							if($(this).attr('disabled') == 'disabled')
								$(moreAction.target).find(idel).attr('disabled','disabled');
							else
								$(moreAction.target).find(idel).removeAttr('disabled');
							console.log('checked', this.checked);
							if(this.checked)
								$(moreAction.target).find(idel)[0].checked=true;
						});
						$(moreAction.target).find('form').off('submit').on('submit', function(event) {
							_this.submitForm(this);
							return false;
							/* Act on the event */
						});
					});
				}
				
			}
		}

		AjaxInfoEl.prototype.submitForm = function (form) {
			var _this=this;
			if(!this.formSubmit){
				this.formSubmit=true;
				var $form=$(form);
				var arrData=$form.serializeArray();
				var data=$form.serialize();
				data+='&ajax=true';
				$form.addClass('loading');
				var ajform=new AJAX($form.attr('action'),$form.attr('method'),data);
				ajform.response
					.done(function (data) {
						console.log('form Response',arrData);
						var all=false;
						if(_this.$modal){
							_this.$modal.modal('hide');
						}

						$('.defaultel').each(function(index, el) {
							var id= $(this).attr('id');
							$(this).html($(data).find('#'+id).html());
						});
						$('.aggiungi.indirizzi').html($(data).find('.aggiungi.indirizzi').html());

						G.AjaxInfo.update();
					})
					.always(function () {
						_this.formSubmit=false;
						$form.removeClass('loading');
					})
			}

		}
	//--AJAXINFO
	
	//NEWSLETTER
		function Newsletter(el) {
			this.el=el;
			this.$el=$(el);

			this.events();
		}

		Newsletter.prototype.events = function () {
			var _this=this;
			this.$el.on('submit',function () {
				
				$(this).parent().removeClass('concluso').addClass('attendere');
				var $this=$(this);
				var aj= new AJAX($(this).attr('action'),$(this).attr('method'),$(this).serialize());
				aj.response
					.always(function(data) {
						$this.parent().toggleClass('attendere concluso');
					})
					.done(function (data) {
						console.log('newsletter result', data);

					})
				return false;
			})
			.find('input').on('input',function () {
				if($(this).val().length>0){
					$(this).addClass('typed');
				}
				else{
					$(this).removeClass('typed');
				}
			});
		}
	//-NEWSLETTER

	//SALES DETAILS
		function SalesDetails(el) {
			this.el=el;
			this.$el=$(el);
			var _this=this;
			this.$el.on('click',function (e) {
				_this.getDetails(e);
			})
		}

		SalesDetails.prototype.getDetails = function (e) {
			e.preventDefault();
			var $el=$(e.target);
			var target=$el.attr('data-target');
			var dati=JSON.parse($el.attr('data-info'));
			this.emptyModal(target);
			this.setData(target,dati);

			$(target).modal();
			return false;
		}

		SalesDetails.prototype.emptyModal = function (target) {
			$(target).find('td').parent('tr').remove();
			$(target).find('.order span + span').text('');
			//$(target).find('table').addClass('loading');
		}

		SalesDetails.prototype.setData = function (el,dati) {
			
			$(el).find('.n-order').text(dati.order);
			$(el).find('.status').text(dati.status);
			var tbody=$(el).find('tbody');
			var l=dati.data.length;
			for(var i=0; i<l; i++){
				var d=dati.data[i];
				var tr=$('<tr id="item-'+d.id+'"></tr>').appendTo(tbody);
				tr.append('<td>'+d.name+'</td><td>'+d.sku+'</td>');
				tr.append('<td>'+d.price+'</td>');
				tr.append('<td class="qty">'+d.qty+'</td>');
				tr.append('<td>'+d.subtotal+'</td>');
			}
			
		}
	//--SALES DETAILS

	//SLIM SCROLL
		function slimScroll(el){
			this.setup(el);
			var _this=this;
			$('body').on('changeSection',function (e,evt) {
				console.log(evt);
				if(evt=="review"){
					console.log('yessss');
					_this.setup('#tabella-review');
				}				
			})
		}

		slimScroll.prototype.setup = function (el) {
			console.log('setup!!');
			$(el).slimScroll({
				railVisible: false,
    			alwaysVisible: true,
    			height:'200px',
    			allowPageScroll: false,
    			borderRadius:0,
    			color:'#f2f2f2',
    			opacity:1
			});
		}
	//--SLIM SCROLL
	


	//NO CLASS IN PAGINA LOGOUT
	function noClass(){
		if($('.wrapper-sezione').hasClass('wrapper-logout')){
			$('body').removeClass('page-account');
		}
	}
	//--NO CLASS IN PAGINA LOGOUT

	//MEDIA SECTION
		function mediaSection(el) {

			this.el=el;
			this.$el=$(el);
			this.cont=[];
			var _this=this;
			this.$el.each(function(index, el) {
				var mel=new mediaSectionEl(el,_this);
				_this.cont.push(mel);
			});
		}

		function mediaSectionEl(el, cont) {
			console.log('test');
			this.el=el;
			this.$el=$(el);
			this.mask=this.$el.children('.media-mask');
			this.MScont=cont;
			this.videoid=this.$el.find('.urlvideo').val();
			this.start=false;
			this.mouseenter=false;
			this.opt={
				"id"				: this.videoid,
				'title'			: 0,
		    'byline'		: 0,
		    'portrait'	: 0,
		    "color"			:"ffffff",	
		    "loop"			: true
			}
			this.events();
		}

		mediaSectionEl.prototype.fnstart = function () {
			this.iframe.stop().fadeIn(200);
			this.player.play();
			this.player.setVolume(0);
		}

		mediaSectionEl.prototype.checkplay = function () {
			if(this.start){
				this.fnstart();
			}
			else{
				var _this=this;
				
				this.player=new Vimeo.Player(this.$el[0], this.opt);
					_this.player.ready().then(function () {
						_this.iframe=_this.$el.find('iframe');
						console.log(_this.iframe);
						_this.iframe.hide();
						
						_this.start=true;
						if(_this.mouseenter)
							_this.fnstart();
					})
				//this.player.loadVideo(this.videoid).then(function () {
				//})
			}
		}

		mediaSectionEl.prototype.events = function () {
			var _this=this;
			this.mask.off('mouseenter').on('mouseenter',function () {
				_this.mouseenter=true;
				_this.checkplay();
			})
			.off('mouseleave').on('mouseleave',function () {
				_this.player.pause();
				_this.iframe.stop().fadeOut(200);
				_this.mouseenter=false;
			})
			
		}
	////MEDIA SECTION


})(jQuery);